// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".planning-select{display:flex;align-items:center;gap:3px}.planning-select>div{color:#a7b3be;background:#ecf0f4;padding:1px;height:24px;width:24px;font-weight:600;line-height:24px;border-radius:3px;cursor:pointer;user-select:none}.planning-select>div.active{color:#1E2B4E;background:#b6e7ff}.planning-select>div:hover{filter:brightness(0.97)}\n", ""]);
// Exports
module.exports = exports;
